// Admin axios client. SAME pattern as ../lib/api.js (withCredentials: true) so
// the httpOnly sf_admin cookie is sent on every admin call automatically. The
// frontend NEVER reads the cookie — auth state is derived from /api/admin/me.
import axios from "axios";
import { logger } from "./logger";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
